// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2342":"d8e835b9eb645d87","5587":"b70418422d3bbe79"}[chunkId] + ".css";
};